import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'lin-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: false,
})
export class InfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) {}
}
